import React from "react";
import Joyride, { STATUS, ACTIONS } from "react-joyride";
import CustomTooltip from "./CustomTooltip";

const NullBeacon = React.forwardRef(() => null);

const ProductTour = ({
  run,
  steps,
  onFinish,
  onClose,
}) => {
  return (
    <Joyride
      run={run}
      steps={steps}
      continuous
      showSkipButton
      scrollToFirstStep
      disableOverlayClose
      disableBeacon
      beaconComponent={NullBeacon}
      tooltipComponent={CustomTooltip}
      styles={{
        options: {
          primaryColor: "#4318FF",
          zIndex: 999999,
        },
      }}
      callback={(data) => {
        const { status, action } = data;

        // Finish current page tour
        if (status === STATUS.FINISHED) {
          onFinish();
          return;
        }

        // Skip current page tour
        if (status === STATUS.SKIPPED) {
          onFinish();
          return;
        }

        // Close (✕) → stop entire tour
        if (action === ACTIONS.CLOSE) {
          onClose();
          return;
        }
      }}
    />
  );
};

export default ProductTour;